// =========================================================
// Vojjin UTILS Utilities
// =========================================================

;(function (global) {
    // Create namespace
    const G = global.gemini || (global.gemini = {});
    G.utils = {};

    G.utils.isNumeric = function (number) {
        return !isNaN(parseFloat(number)) && isFinite(number);
    }

    G.utils.isEmpty = function (anyValue) {
        if (anyValue === null || anyValue === undefined) return true;
        if (G.utils.isNumeric(anyValue)) return parseFloat(anyValue) === 0;
        if (G.utils.isBoolean(anyValue)) return anyValue === false;
        if (G.utils.isArray(anyValue)) return anyValue.length === 0;
        if (G.utils.isObject(anyValue)) return Object.keys(anyValue).length === 0;
        return anyValue.toString().trim() === "";
    }

    G.utils.isBoolean = function (anyValue) {
        return typeof anyValue === "boolean";
    }

    G.utils.isArray = function (anyValue) {
        return Array.isArray(anyValue);
    }

    G.utils.isObject = function (anyValue) {
        return typeof anyValue === "object";
    }

    G.utils.exists = function (anyValue) {
        return !G.utils.isEmpty(anyValue);
    }

    G.utils.inArray = function (array, searchValue) {
        if (!(G.utils.isArray(array))) return false;
        for (let i = 0; i < array.length; i++) {
            if (array[i] === searchValue) return i;
        }
        return false;
    }

    G.utils.copyToClipboard = function (text) {
        try {
            navigator.clipboard.writeText(text).then(r => {
            });
        } catch (err) {
            console.error("Failed to copy to clipboard: ", err);
        }
    }

    if (typeof module !== "undefined" && module.exports) {
        module.exports = G.utils;
    } else {
        global.gemini = G;
        global.gemini.utils = G.utils;

    }
})(typeof globalThis !== "undefined" ? globalThis : this);
